import { useState, useEffect } from 'react'
import {Shield, Wrench, Zap, Phone, Mail, MapPin, ChevronRight, CheckCircle2} from 'lucide-react'

function Home() {
  const [products, setProducts] = useState([
    { name: 'Vaso inox antivandalismo', quantity: 0, checked: false },
    { name: 'Lavatório inox antivandalismo', quantity: 0, checked: false },
    { name: 'Conjugado inox antivandalismo', quantity: 0, checked: false },
    { name: 'Mictório inox antivandalismo', quantity: 0, checked: false },
    { name: 'Bacia sanitária acoplado cx d\'água', quantity: 0, checked: false },
    { name: 'Lavatório inox antivandalismo premium', quantity: 0, checked: false }
  ])

  const [formData, setFormData] = useState({
    empresa: '',
    cnpj: '',
    nome: '',
    telefone: ''
  })

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const handleProductChange = (index: number, field: 'checked' | 'quantity', value: boolean | number) => {
    const newProducts = [...products]
    if (field === 'checked') {
      newProducts[index].checked = value as boolean
      if (!(value as boolean)) {
        newProducts[index].quantity = 0
      } else if (newProducts[index].quantity === 0) {
        newProducts[index].quantity = 1
      }
    } else {
      newProducts[index].quantity = value as number
    }
    setProducts(newProducts)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    const selectedProducts = products
      .filter(p => p.checked && p.quantity > 0)
      .map(p => `${p.name}: ${p.quantity}`)
      .join('%0A')

    if (!selectedProducts) {
      alert('Por favor, selecione pelo menos um produto!')
      return
    }
    
    const productLines = products
      .filter(p => p.checked && p.quantity > 0)
      .map(p => `${p.name}: ${p.quantity}`)
      .join('%0A')

    const mensagem = `Olá, gostaria de solicitar orçamento de sanitários inox antivandalismo:%0A%0AEmpresa: ${formData.empresa}%0ACNPJ: ${formData.cnpj}%0ANome: ${formData.nome}%0ATelefone: ${formData.telefone}%0A%0AItens:%0A${productLines}%0A%0ALocal de uso: %0A%0AAguardo retorno.`
    
    const url = `https://wa.me/5554996542326?text=${mensagem}`
    window.open(url, '_blank')
  }

  const handleWhatsAppContact = () => {
    const mensagem = encodeURIComponent('Olá, solicito orçamento para obras!')
    const url = `https://wa.me/5554996542326?text=${mensagem}`
    window.open(url, '_blank')
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const productGallery = [
    {
      name: 'Vaso Inox Antivandalismo',
      image: 'https://static.lumi.new/2c/2c10d059adcda61a4ed85d840d0f695c.webp'
    },
    {
      name: 'Conjugado Inox Antivandalismo',
      image: 'https://static.lumi.new/56/56fe2a7a0051b0943c2edf58a9e5f2ba.webp'
    },
    {
      name: 'Vaso Sanitário Acoplado cx d\'água em Inox',
      image: 'https://static.lumi.new/material/5d/5d5a579d6c5e61831dc450a0879431cf.jpg'
    },
    {
      name: 'Mictório Inox Antivandalismo',
      image: 'https://static.lumi.new/ba/ba70cd681705e47b06b12f5d752ce132.webp'
    },
    {
      name: 'Lavatório Inox Antivandalismo',
      image: 'https://static.lumi.new/71/713e1ffdb3d892fd43cd1b3195b9b61e.webp'
    },
    {
      name: 'Lavatório Inox Antivandalismo Premium',
      image: 'https://static.lumi.new/4d/4d5f5d1a0a16cc2609fdf1818ffe1a33.webp'
    }
  ]

  const benefits = [
    {
      icon: Shield,
      title: 'Evite prejuízo com vandalismo',
      description: 'Projetado para resistir à depredação e vandalismo extremo'
    },
    {
      icon: Wrench,
      title: 'Reduza custos operacionais',
      description: 'Menos manutenção e menor custo operacional a longo prazo'
    },
    {
      icon: Zap,
      title: 'Elimine trocas frequentes',
      description: 'Durabilidade superior elimina necessidade de substituições constantes'
    },
    {
      icon: CheckCircle2,
      title: 'Aumente a durabilidade dos equipamentos',
      description: 'Vida útil muito superior aos materiais convencionais'
    }
  ]

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      {/* Header */}
      <header className="bg-[#1a1a1a] shadow-lg shadow-[#ff7a00]/20 sticky top-0 z-50 border-b-2 border-[#ff7a00]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex justify-between items-center">
          <img 
            src="https://static.lumi.new/6e/6e5966b6ae45a03edffa3aeca1932151.webp" 
            alt="Inoxy Logo" 
            width="281"
            height="84"
            fetchpriority="high"
            className="h-10 sm:h-12 md:h-16 w-auto object-contain drop-shadow-[0_0_10px_rgba(255,122,0,0.5)]"
          />
          <div className="flex items-center gap-3 sm:gap-4">
            <a 
              href="https://wa.me/5554996542326" 
              className="hidden sm:flex items-center gap-2 text-[#ff7a00] font-bold text-sm md:text-base hover:text-[#ff9500] transition-colors"
            >
              <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>54 99654-2326</span>
            </a>
            <button 
              onClick={handleWhatsAppContact}
              className="flex items-center gap-1 sm:gap-2 bg-gradient-to-r from-[#ff7a00] to-[#ff9500] hover:from-[#e86d00] hover:to-[#ff7a00] px-3 sm:px-4 md:px-6 py-2 sm:py-3 rounded-lg font-bold text-sm sm:text-base transition-all duration-300 hover:scale-105 shadow-lg shadow-[#ff7a00]/50 hover:shadow-[#ff7a00]/70"
            >
              <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
              <span className="hidden sm:inline">Fale Conosco</span>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#ff7a00] via-[#ff4500] to-[#0a0a0a] opacity-30 animate-gradient"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(255,122,0,0.2),transparent_50%)]"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-24 relative z-10">
          <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Left Content */}
            <div className={`space-y-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <div className="inline-block bg-gradient-to-r from-[#ff7a00] to-[#ff9500] px-6 py-3 rounded-full text-sm font-bold animate-pulse shadow-lg shadow-[#ff7a00]/50">
                🛡️ MÁXIMA SEGURANÇA GARANTIDA
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black leading-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] via-[#ff9500] to-[#ffa040] drop-shadow-[0_0_30px_rgba(255,122,0,0.8)]">
                  VASO SANITÁRIO INOX
                </span>
                <br />
                <span className="text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.3)]">ANTI-VANDALISMO PARA PRESÍDIOS</span>
              </h1>
              
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-200 font-bold drop-shadow-lg">
                Resiste à depredação, reduz custos com manutenção e suporta uso intenso 24h.
              </h2>
              
              <p className="text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed">
                Soluções em inox desenvolvidas para ambientes críticos com alto índice de vandalismo e uso extremo.
              </p>
              
              <ul className="space-y-4">
                <li className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base md:text-lg bg-[#1a1a1a]/50 p-3 sm:p-4 rounded-lg border-l-4 border-[#ff7a00] backdrop-blur-sm">
                  <CheckCircle2 className="w-6 h-6 sm:w-8 sm:h-8 text-[#ff7a00] flex-shrink-0" />
                  <span className="font-semibold">Não quebra nem com impacto</span>
                </li>
                <li className="flex items-center gap-3 text-lg bg-[#1a1a1a]/50 p-4 rounded-lg border-l-4 border-[#ff7a00] backdrop-blur-sm">
                  <CheckCircle2 className="w-8 h-8 text-[#ff7a00] flex-shrink-0" />
                  <span className="font-semibold">Reduz custos operacionais</span>
                </li>
                <li className="flex items-center gap-3 text-lg bg-[#1a1a1a]/50 p-4 rounded-lg border-l-4 border-[#ff7a00] backdrop-blur-sm">
                  <CheckCircle2 className="w-8 h-8 text-[#ff7a00] flex-shrink-0" />
                  <span className="font-semibold">Alta durabilidade industrial</span>
                </li>
                <li className="flex items-center gap-3 text-lg bg-[#1a1a1a]/50 p-4 rounded-lg border-l-4 border-[#ff7a00] backdrop-blur-sm">
                  <CheckCircle2 className="w-8 h-8 text-[#ff7a00] flex-shrink-0" />
                  <span className="font-semibold">Ideal para ambientes de alto risco</span>
                </li>
              </ul>
              

            </div>

            {/* Right Form */}
            <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <div className="bg-gradient-to-br from-white to-gray-100 rounded-2xl shadow-2xl shadow-[#ff7a00]/30 p-4 sm:p-6 md:p-8 transform hover:scale-[1.02] transition-transform duration-300 border-4 border-[#ff7a00]/50">
                <div className="text-center mb-6">
                  <div className="inline-block bg-gradient-to-r from-[#ff7a00] to-[#ff9500] text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                    💼 ORÇAMENTO GRÁTIS
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-black text-[#1a1a1a] mb-2">
                    Solicite um Orçamento
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700 font-semibold">Atendimento exclusivo para empresas e órgãos públicos</p>
                </div>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-bold text-gray-800 mb-2">
                      Nome da Empresa *
                    </label>
                    <input
                      type="text"
                      name="empresa"
                      value={formData.empresa}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#ff7a00] focus:ring-2 focus:ring-[#ff7a00]/30 focus:outline-none transition-all text-gray-900 font-medium"
                      placeholder="Ex: Construções Ltda"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-800 mb-2">
                      CNPJ *
                    </label>
                    <input
                      type="text"
                      name="cnpj"
                      value={formData.cnpj}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#ff7a00] focus:ring-2 focus:ring-[#ff7a00]/30 focus:outline-none transition-all text-gray-900 font-medium"
                      placeholder="00.000.000/0000-00"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-800 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#ff7a00] focus:ring-2 focus:ring-[#ff7a00]/30 focus:outline-none transition-all text-gray-900 font-medium"
                      placeholder="Seu nome"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-800 mb-2">
                      Telefone/WhatsApp *
                    </label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#ff7a00] focus:ring-2 focus:ring-[#ff7a00]/30 focus:outline-none transition-all text-gray-900 font-medium"
                      placeholder="(00) 00000-0000"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-800 mb-3">
                      Produtos Desejados *
                    </label>
                    <div className="space-y-3">
                      {products.map((product, index) => (
                        <div key={index} className="flex items-center gap-3 bg-white p-3 rounded-lg border-2 border-gray-200 hover:border-[#ff7a00] transition-colors">
                          <input
                            type="checkbox"
                            id={`product-${index}`}
                            checked={product.checked}
                            onChange={(e) => handleProductChange(index, 'checked', e.target.checked)}
                            className="w-5 h-5 text-[#ff7a00] border-gray-300 rounded focus:ring-[#ff7a00] cursor-pointer"
                          />
                          <label htmlFor={`product-${index}`} className="flex-1 text-sm font-semibold text-gray-800 cursor-pointer">
                            {product.name}
                          </label>
                          <input
                            type="number"
                            min="0"
                            value={product.quantity}
                            onChange={(e) => handleProductChange(index, 'quantity', parseInt(e.target.value) || 0)}
                            disabled={!product.checked}
                            className="w-20 px-2 py-2 border-2 border-gray-300 rounded-lg focus:border-[#ff7a00] focus:outline-none transition-colors text-gray-900 font-bold text-center disabled:bg-gray-100 disabled:cursor-not-allowed"
                            placeholder="Qtd"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-[#ff7a00] to-[#ff9500] hover:from-[#e86d00] hover:to-[#ff7a00] text-white font-black py-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-[#ff7a00]/50 flex items-center justify-center gap-3 text-lg border-2 border-[#ff9500]"
                  >
                    <Phone className="w-6 h-6" />
                    SOLICITAR ORÇAMENTO IMEDIATO
                    <ChevronRight className="w-6 h-6" />
                  </button>
                  <p className="text-center text-sm text-gray-600 font-semibold mt-4">
                    ✅ Receba retorno rápido no WhatsApp com proposta técnica
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Gallery Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <div className="inline-block bg-gradient-to-r from-[#ff7a00] to-[#ff9500] text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              🏆 LINHA PROFISSIONAL
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-4">
              Nossos <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] to-[#ff9500]">Produtos</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-400">Alta resistência e durabilidade comprovada</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {productGallery.map((product, index) => (
              <div 
                key={index}
                className="group bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-[#ff7a00]/30 transition-all duration-500 transform hover:-translate-y-3 border-2 border-[#ff7a00]/20 hover:border-[#ff7a00]"
              >
                <div className="relative aspect-square overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    width="602"
                    height="602"
                    loading="lazy"
                    className="w-full h-full object-contain bg-white group-hover:scale-110 transition-transform duration-700 p-4"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-white group-hover:text-[#ff7a00] transition-colors">
                    {product.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Problems Section */}
      <section className="py-16 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-red-600 to-red-800 text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              ⚠️ PROBLEMAS COMUNS
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] to-[#ff9500]">PROBLEMAS QUE RESOLVEMOS</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Ambientes de alto fluxo sofrem com vandalismo constante, gerando custos elevados com manutenção e substituição de equipamentos.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-red-900/30 to-red-800/20 p-6 rounded-xl border-2 border-red-600/50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-2xl">❌</span>
                </div>
                <h3 className="text-xl font-bold text-white">Depredação frequente de sanitários</h3>
              </div>
            </div>
            <div className="bg-gradient-to-br from-red-900/30 to-red-800/20 p-6 rounded-xl border-2 border-red-600/50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-2xl">💸</span>
                </div>
                <h3 className="text-xl font-bold text-white">Alto custo com manutenção</h3>
              </div>
            </div>
            <div className="bg-gradient-to-br from-red-900/30 to-red-800/20 p-6 rounded-xl border-2 border-red-600/50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-2xl">🔄</span>
                </div>
                <h3 className="text-xl font-bold text-white">Trocas constantes de equipamentos</h3>
              </div>
            </div>
            <div className="bg-gradient-to-br from-red-900/30 to-red-800/20 p-6 rounded-xl border-2 border-red-600/50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-2xl">⏱️</span>
                </div>
                <h3 className="text-xl font-bold text-white">Baixa durabilidade de materiais comuns</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-green-600 to-green-800 text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              ✅ A SOLUÇÃO
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] to-[#ff9500]">A SOLUÇÃO EM INOX ANTI-VANDALISMO</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Nossos equipamentos são projetados para resistir a impactos, uso extremo e tentativa de depredação, garantindo longa vida útil e economia real.
            </p>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-16 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-[#ff7a00] to-[#ff9500] text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              🏢 APLICAÇÕES
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-8">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] to-[#ff9500]">IDEAL PARA:</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 sm:gap-6">
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">🔒</div>
              <h3 className="text-lg font-bold text-white">Presídios</h3>
            </div>
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">👮</div>
              <h3 className="text-lg font-bold text-white">Delegacias</h3>
            </div>
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">⚖️</div>
              <h3 className="text-lg font-bold text-white">Fóruns</h3>
            </div>
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">🏥</div>
              <h3 className="text-lg font-bold text-white">Hospitais</h3>
            </div>
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">✈️</div>
              <h3 className="text-lg font-bold text-white">Aeroportos</h3>
            </div>
            <div className="bg-gradient-to-br from-[#2d2d2d] to-[#1a1a1a] p-6 rounded-xl text-center border-2 border-[#ff7a00]/30 hover:border-[#ff7a00] transition-all hover:scale-105">
              <div className="text-5xl mb-3">🚢</div>
              <h3 className="text-lg font-bold text-white">Navios</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-[#ff7a00] to-[#ff9500] text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              💪 DIFERENCIAIS
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff7a00] to-[#ff9500]">POR QUE ESCOLHER INOX ANTI-VANDALISMO</span>
            </h2>
            <p className="text-xl text-gray-400">Tecnologia de ponta em resistência e durabilidade</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="group bg-gradient-to-br from-white to-gray-100 text-[#1a1a1a] rounded-2xl p-6 sm:p-8 shadow-xl hover:shadow-2xl hover:shadow-[#ff7a00]/30 transition-all duration-500 transform hover:-translate-y-3 border-4 border-transparent hover:border-[#ff7a00]"
              >
                <div className="bg-gradient-to-br from-[#ff7a00] to-[#ff9500] w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl sm:text-2xl font-black mb-3 group-hover:text-[#ff7a00] transition-colors">{benefit.title}</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-[#ff7a00] via-[#ff9500] to-[#ff7a00] relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(255,255,255,0.1),transparent_50%)] animate-pulse"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-black mb-6 drop-shadow-lg">
            📞 SOLICITE UM ORÇAMENTO AGORA
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-8 sm:mb-10 font-bold drop-shadow-md">
            Fale com um especialista e receba uma proposta rápida e personalizada para sua necessidade.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-2 sm:gap-3 bg-white text-[#ff7a00] px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-xl font-black text-base sm:text-lg md:text-xl hover:bg-gray-100 transition-all duration-300 transform hover:scale-110 shadow-2xl hover:shadow-white/50 border-4 border-white"
          >
            📝 Solicitar Orçamento Imediato
            <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
          </button>
        </div>
      </section>

      {/* SEO Text Section */}
      <section className="py-12 bg-[#0a0a0a]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] p-8 rounded-2xl border border-[#ff7a00]/20">
            <h2 className="text-2xl font-bold text-[#ff7a00] mb-4">Equipamentos Sanitários em Inox Antivandalismo</h2>
            <p className="text-gray-300 leading-relaxed">
              Equipamentos sanitários em inox antivandalismo são ideais para ambientes com alto fluxo e risco de depredação. Utilizados em presídios, delegacias, hospitais e aeroportos, garantem resistência, durabilidade e redução significativa de custos com manutenção.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-gray-400 py-12 border-t-2 border-[#ff7a00]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-8">
            <div>
              <img 
                src="https://static.lumi.new/6e/6e5966b6ae45a03edffa3aeca1932151.webp" 
                alt="Inoxy Logo" 
                width="281"
                height="84"
                loading="lazy"
                className="h-12 w-auto object-contain mb-4 drop-shadow-[0_0_10px_rgba(255,122,0,0.5)]"
              />
              <p className="text-sm font-medium">
                Soluções em inox de alta resistência para ambientes críticos
              </p>
            </div>
            
            <div>
              <h4 className="text-white font-bold mb-4 text-lg">📞 Contato</h4>
              <div className="space-y-3">
                <a href="https://wa.me/5554996542326" className="flex items-center gap-2 hover:text-[#ff7a00] transition-colors font-medium">
                  <Phone className="w-5 h-5" />
                  <span>(54) 99654-2326</span>
                </a>
                <a href="tel:+555433440135" className="flex items-center gap-2 hover:text-[#ff7a00] transition-colors font-medium">
                  <Phone className="w-5 h-5" />
                  <span>(54) 3344-0135</span>
                </a>
                <a href="mailto:franciscowitschoreck@gmail.com" className="flex items-center gap-2 hover:text-[#ff7a00] transition-colors font-medium">
                  <Mail className="w-5 h-5" />
                  <span className="text-sm">franciscowitschoreck@gmail.com</span>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-white font-bold mb-4 text-lg">📍 Localização</h4>
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-[#ff7a00]" />
                <span className="text-sm font-medium">
                  Rua Leorindo Cavichiolli, 729, Centro<br />
                  Tapejara, RS, Brasil - CEP: 99950-000
                </span>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="font-medium">© 2024 Inoxy Soluções em Inox. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppContact}
        className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#25D366]/50 transition-all duration-300 transform hover:scale-110 z-50 animate-bounce"
        aria-label="Fale Conosco WhatsApp"
      >
        <Phone className="w-6 h-6 sm:w-8 sm:h-8" />
      </button>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 15s ease infinite;
        }
      `}</style>
    </div>
  )
}

export default Home
